import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend/index'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import { Link } from "react-router-dom";
import { Base64 } from "js-base64";
import Icon from "../common/icon/icon.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx"
import { integrationKeyLightspeedEcom, integrationKeyQuickbooks } from '../integration/IntegrationConstants.jsx'
const queryString = require('query-string')
import 'react-vimeo/lib/Vimeo.css'


const messages = defineMessages({
    docTitle: {
        id: 'signup.docHeader.title',
        defaultMessage: 'QuoteMachine - Powerful proposals.',
    },
    error_invalid_token: {
        id: 'signup.error_invalid_token',
        defaultMessage: 'Error connecting with the store with id ({value}). Contact support. ',
    },
    error_server_connection: {
        id: 'signup.error.error_server_connection',
        defaultMessage: 'Error connecting with the store with id ({value}). Try to reinstall the application. ',
    },
    error_email_already_exists: {
        id: 'signup.error.email_already_exists',
        defaultMessage: 'The email associated with your {integrationName} account ({value}) already exists in our system. {linebreak} '
            + 'You should have received an email from QuoteMachine containing your temporary credentials which are different from the ones you use in {integrationName}.'
            + 'Use them to connect to QuoteMachine or please contact our support.',
    },
    error_no_access_rights: {
        id: 'signup.error.no_access_rights',
        defaultMessage: "The user {value} is not an administrator or owner. Please contact your adminstrator/owner in {integrationName} to get your credentials for QuoteMachine.",
    },
    error_creating_user: {
        id: 'signup.error.creating_user',
        defaultMessage: "Your user with email address ({value}) could not be created. In {integrationName}, verify that the field Email of your employee is set correctly and try again.",
    },
    user_disabled: {
        id: 'signup.error.user_disabled_error',
        defaultMessage: "Your user with email address ({value}) is disabled. You have reached you maximum number of users or have been blocked, please contact your account manager to enable it",
    },
    error_invalid_email: {
        id: 'signup.error.invalid_email',
        defaultMessage: "Your user's email address ({value}) is invalid. In {integrationName}, verify that the field Email 1 of your employee is set correctly and try again.",
    },
    error_external_account_already_connected: {
        id: 'signup.error.external_account_already_connected',
        defaultMessage: "The {integrationName} account {value} is already connected to an existing QuoteMachine account. If you're an employee, contact your administrator/owner to get your credentials.",
    },
    error_integration_does_not_exists: {
        id: 'signup.error.external_account_no_integration',
        defaultMessage: "You don't have an integration with an existing QuoteMachine account. Please sign up with {integrationName} before trying to sign in",
    },
    error_account_does_not_exists: {
        id: 'signup.error.external_account_no_account',
        defaultMessage: "You don't have a QuoteMachine account. Please sign up with {integrationName} before trying to sign in",
    },
});

class ErrorAuthComponent extends Component {

    constructor(props, context) {
        super(props, context);

        const uri = queryString.parse(this.props.location.search)
        this.state = {
            queryString: uri,
            authErrorEncoded: uri.berr || "",
            authError: "",
            integrationKey: this.props.match.params.integrationKey || '',
        }
    }

    componentDidMount() {
        document.title = this.props.intl.formatMessage(messages.docTitle)
        this.setupIntercom()
        if (this.state.authErrorEncoded) {
            try {
                const error = JSON.parse(Base64.decode(this.state.authErrorEncoded))
                let errorMessage = ''
                if (typeof error === "string") {
                    errorMessage = error
                } else if (error.error) {
                    errorMessage = error.error.message
                }
                const parsedMessage = errorMessage.split(':')
                const errorMessageId = parsedMessage[0]
                let value = ''
                if (parsedMessage.length > 1) {
                    value = parsedMessage[1]
                }

                this.setState({
                    authError: <p className={'text-danger mt-3 mb-0 text-justify'}>
                        <Icon value={'exclamation'} className={'mr-1'} />
                        {messages[errorMessageId] ? <FormattedMessage
                            {...messages[errorMessageId]}
                            values={{
                                value: value,
                                integrationName: this.state.integrationKey,
                                linebreak: <span><br /><br /></span>,
                            }}
                        /> : errorMessage}
                    </p>
                })
            } catch (e) {
                console.log(e)
            }
        }
    }

    setupIntercom() {
        window.Intercom("boot", {
            app_id: GlobalHelper.getIntercomAppId(),
        })
        window.intercomSettings = {
            app_id: GlobalHelper.getIntercomAppId(),
            app_environment: AppContext.getOptions().environment,
            language_override: AppContext.getLocale().language,
        }
        window.Intercom("update")
    }

    render() {
        return (
            <div>
                <div className="d-flex justify-content-center my-4">
                    <div className="col-xl-6 col-lg-7 col-md-9 col-12">
                        <div className="row">
                            <div className="col-12 mt-4">
                                <h1 className="text-center">
                                    <img src='/images/QuoteM_horizontal_flat.png' height='80px' />
                                </h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <div className="row justify-content-center flex-fill">
                                    <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12 col-xl-12 bg-white ui-module py-4 px-3 px-sm-5"
                                        style={{
                                            "borderLeftRightRadius": 0,
                                            "borderTopRightRadius": 0,
                                        }}>
                                        <div className="row justify-content-center mb-3 mt-3">
                                            {this.state.authError}
                                        </div>
                                    </div>
                                    {this.state.integrationKey && [integrationKeyLightspeedEcom].includes(this.state.integrationKey) && <div className="col-12">
                                        <p className="text-align-center">
                                            <Link to={'/p/signin?integrationKey=' + this.state.integrationKey}>
                                                <FormattedMessage
                                                    id="sign_in.already_have_account"
                                                    defaultMessage="Already have an account ?"
                                                />
                                            </Link>
                                        </p>
                                    </div>}
                                    {this.state.integrationKey && integrationKeyQuickbooks.includes(this.state.integrationKey) &&
                                        <div className="col-12">
                                            <p className="text-align-center">
                                                <Link to={'/p/signup'}>
                                                    <FormattedMessage
                                                        id="sign_in.no_account_yet"
                                                        defaultMessage="You don't have an account yet?"
                                                    />
                                                </Link>
                                            </p>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default injectIntl(ErrorAuthComponent);


// WEBPACK FOOTER //
// ./src/auth/errorauth.component.jsx